import { IconToggleButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, useCallback } from "react"

import { useEditorFocused, useFallbackEditor, useStrikeState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface StrikeToggleButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconToggleButton>, "children">, OptionalEditorProps {}

export const StrikeToggleButton = memo<StrikeToggleButtonProps>((props) => {
	const { ref, editor: editorFromProps, pressed, onPressedChange, disabled, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const isEditorFocused = useEditorFocused(editor)
	const state = useStrikeState(editor)

	const handlePressedChange = useCallback(
		(pressed: boolean) => {
			onPressedChange?.(pressed)
			editor?.chain().focus().toggleStrike().run()
		},
		[editor, onPressedChange],
	)

	return (
		<IconToggleButton
			ref={ref}
			pressed={pressed ?? (state.isActive && isEditorFocused)}
			onPressedChange={handlePressedChange}
			disabled={disabled ?? !state.canToggle}
			{...rest}
		>
			<LuIcon icon={tipTapIconMapping.strike} />
		</IconToggleButton>
	)
})
StrikeToggleButton.displayName = "StrikethroughToggleButton"
